import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BookOpen, ArrowRight } from 'lucide-react';
import { fetchMuseumShareStats } from '../utils/museumCoLearningStats';

const CO_LEARNING_PATH = '/gallery/studio';

/**
 * Toolbar CTA: Open Artist Salon (co-learning) + shared count.
 */
export default function MuseumExploreCta({ uid, className = 'studio-co-learning-cta', compact = false }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [totalShared, setTotalShared] = useState(0);

  useEffect(() => {
    if (!uid) {
      setLoading(false);
      setTotalShared(0);
      return;
    }

    let cancelled = false;
    fetchMuseumShareStats(uid)
      .then((stats) => {
        if (!cancelled) setTotalShared(stats.totalShared ?? 0);
      })
      .catch(() => {
        if (!cancelled) setTotalShared(0);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [uid]);

  if (!uid) return null;

  const ariaLabel = loading
    ? 'Open Artist Salon'
    : `Artist Salon, ${totalShared} shared`;

  return (
    <button
      type="button"
      onClick={() => navigate(CO_LEARNING_PATH)}
      className={`${className} max-w-full`}
      title={ariaLabel}
      aria-label={ariaLabel}
    >
      <BookOpen className="h-4 w-4 shrink-0 text-[#8A7357]" aria-hidden />
      <span className="studio-nav-explore-cta-label min-w-0 text-left text-[0.7rem] leading-tight sm:text-[0.78rem]">
        {compact ? (
          loading ? (
            'Artist Salon…'
          ) : (
            <>
              Artist Salon <span className="text-amber-700">({totalShared})</span>
            </>
          )
        ) : loading ? (
          'Open Artist Salon…'
        ) : (
          <>
            Artist Salon — your shared count{' '}
            <span className="text-amber-700">{totalShared}</span>
          </>
        )}
      </span>
      {!compact && (
        <ArrowRight className="h-4 w-4 flex-shrink-0 text-[#8A7357] opacity-80" aria-hidden />
      )}
    </button>
  );
}
